import { render, staticRenderFns } from "./showProfile.vue?vue&type=template&id=504fb380&scoped=true&"
import script from "./showProfile.vue?vue&type=script&lang=js&"
export * from "./showProfile.vue?vue&type=script&lang=js&"
import style0 from "./showProfile.vue?vue&type=style&index=0&id=504fb380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504fb380",
  null
  
)

export default component.exports